import React, { useEffect, useState } from 'react';
import axios from 'axios';

const OwnerOrders = () => {
    const [orders, setOrders] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [error, setError] = useState(null);
    const API_URL = process.env.REACT_APP_API_URL;


    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const token = localStorage.getItem('ownerToken');
                if (!token) {
                    setError('Aucun jeton trouvé. Veuillez vous connecter.');
                    return;
                }

                const base64Url = token.split('.')[1];
                const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                const jsonPayload = JSON.parse(atob(base64));
                const ownerId = jsonPayload.id;

                if (!ownerId) {
                    setError("Aucun ownerId dans le jeton. Veuillez vous connecter.");
                    return;
                }

                const response = await axios.get(`${API_URL}/api/owner-orders/${ownerId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                const ordersWithStatus = response.data.orders.map((order) => ({
                    ...order,
                    status: 'Préparation',
                }));

                setOrders(ordersWithStatus);
            } catch (err) {
                setError(err.message || 'Une erreur s\'est produite lors de la récupération des commandes.');
                console.error('Erreur lors de la récupération des commandes:', err);
            }
        };

        fetchOrders();
    }, []);

    const updateOrderStatus = (orderId) => {
        setOrders((prevOrders) =>
            prevOrders.map((order) => {
                if (order.orderId === orderId) {
                    let newStatus = order.status;
                    if (order.status === 'Préparation') newStatus = 'Prêt à être récupéré';
                    else if (order.status === 'Prêt à être récupéré') newStatus = 'Livré';
                    return { ...order, status: newStatus };
                }
                return order;
            })
        );
    };

    const handleMarkNoShow = async (userId) => {
        try {
            const token = localStorage.getItem('ownerToken');
            if (!token) {
                setError('Aucun jeton trouvé. Veuillez vous connecter.');
                return;
            }

            const response = await axios.post(
                `${API_URL}/api/owner-orders/mark-no-show/${userId}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                console.log(`Marqué avec succès le client ${userId} comme non-présent.e.`);
                // Optionally, update UI (e.g., disable button, show success message)
            } else {
                console.error(`Échec de la mention du client ${userId} comme non-présent.e. Status: ${response.status}`);
                setError(`Échec de la mention du client comme non-présent.e: ${response.statusText}`);
            }
        } catch (err) {
            console.error("Erreur lors de la mention du client comme non-présent.e:", err);
            setError(`Erreur lors de la mention du client comme non-présent.e: ${err.message}`);
        }
    };

    const handleOrderClick = (order) => {
        setSelectedOrder(order);
    };

    return (
        <div className="owner-order-container">
            {/* Header */}
            <header id="header" className="header">
                <div className="header-container">
                    <div className="header-flex">
                        <div className="header-left">
                            <div className="header-title">Lememeprix</div>
                            <div className="header-address-input-container">
                                <div className="header-address-relative">
                                    <i className="fa-solid fa-location-dot header-address-icon"></i>
                                </div>
                            </div>
                        </div>
                        <div className="header-right">
                            <i className="fa-solid fa-magnifying-glass header-icon"></i>
                            <i className="fa-solid fa-cart-shopping header-icon"></i>
                            <img src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-1.jpg" alt="Profile" className="header-profile-img" />
                        </div>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="main-content">
                {/* Hero Section */}
                <section id="hero-section" className="hero-section">
                    <div className="hero-overlay">
                        <img className="hero-img" src="https://storage.googleapis.com/uxpilot-auth.appspot.com/c93cb05e59-15f23e977b2087cca3a7.png" alt="cinematic shot of gourmet food plating in dark moody lighting" />
                    </div>
                    <div className="hero-container">
                        <h1 className="hero-title">Tableau de bord du propriétaire</h1>
                    </div>
                </section>

                {/* Order Summary */}
                <section id="order-summary" className="order-summary">
                    <div className="order-summary-content">
                        {error && <p className="error-message">{error}</p>}
                        <h3 className="order-title">Commandes</h3>
                        {orders.length > 0 ? (
                            <ul className="order-list">
                                {orders.map((order) => (
                                    <li key={order.orderId} className="order-item">
                                        <div className="order-item-container">
                                            <p
                                                onClick={() => handleOrderClick(order)}
                                                className="order-token"
                                            >
                                                Jeton: {order.orderId}
                                            </p>
                                            {order.status !== 'Livré' && (
                                                <div className="order-actions">
                                                    <button
                                                        onClick={() => updateOrderStatus(order.orderId)}
                                                        className="order-button"
                                                    >
                                                        {order.status === 'Préparation'
                                                            ? 'Prêt à être récupéré'
                                                            : 'Livrer la commande'}
                                                    </button>
                                                    <button
                                                        onClick={() => handleMarkNoShow(order.userId)}
                                                        className="no-show-button"
                                                    >
                                                        Le client n'est pas venu chercher la commande
                                                    </button>
                                                </div>
                                            )}
                                            {order.status === 'Livré' && (
                                                <span className="delivered-status">Livré</span>
                                            )}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="no-orders">Aucune commande disponible.</p>
                        )}

                        {selectedOrder && (
                            <div className="order-details">
                                <h4 className="order-details-title">Détails de la commande (Jeton: {selectedOrder.orderId})</h4>
                                <table border="1" cellPadding="10" className="order-table">
                                    <thead>
                                        <tr>
                                            <th>Nom de l'article</th>
                                            <th>Quantité</th>
                                            <th>Prix ​​par article</th>
                                            <th>Prix ​​total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedOrder.cartItems.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.itemName}</td>
                                                <td>{item.quantity}</td>
                                                <td>{item.price.toFixed(2)}</td>
                                                <td>{(item.quantity * item.price).toFixed(2)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <h5 className="order-total">Prix ​​total de la commande: {selectedOrder.totalPrice.toFixed(2)}</h5>
                            </div>
                        )}
                    </div>
                </section>
            </main>

            {/* Footer */}
            <footer id="footer" className="footer">
                <div className="footer-container">
                    <div className="footer-grid">
                        <div>
                            <h3 className="footer-heading">À propos de Lememeprix</h3>
                            <ul className="footer-list">
                                <li><span className="footer-link">À propos de nous</span></li>
                                <li><span className="footer-link">Carrières</span></li>
                                <li><span className="footer-link">Presse</span></li>
                            </ul>
                        </div>
                        <div>
                            <h3 className="footer-heading">Assistance</h3>
                            <ul className="footer-list">
                                <li><span className="footer-link">Centre d'aide</span></li>
                                <li><span className="footer-link">Contactez nous</span></li>
                                <li><span className="footer-link">Politique de confidentialité</span></li>
                            </ul>
                        </div>
                        <div>
                            <h3 className="footer-heading">Pour les entreprises</h3>
                            <ul className="footer-list">
                                <li><span className="footer-link">Rejoindre en tant que partenaire</span></li>
                                <li><span className="footer-link">Pour les restaurants</span></li>
                                <li><span className="footer-link">Pour les chauffeurs</span></li>
                            </ul>
                        </div>
                        <div>
                            <h3 className="footer-heading">Suivez nous</h3>
                            <div className="footer-social">
                                <span className="footer-social-icon"><i className="fa-brands fa-instagram text-xl"></i></span>
                                <span className="footer-social-icon"><i className="fa-brands fa-facebook text-xl"></i></span>
                                <span className="footer-social-icon"><i className="fa-brands fa-twitter text-xl"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            <style jsx>{`
                .owner-order-container {
                    min-height: 100vh;
                    background-color: #fff;
                    font-family: sans-serif;
                }

                /* Header Styles */
                .header {
                    position: fixed;
                    width: 100%;
                    background-color: #fff;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                    z-index: 50;
                }

                .header-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 1rem;
                }

                .header-flex {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }

                .header-left {
                    display: flex;
                    align-items: center;
                }

                .header-title {
                    font-size: 1.5rem;
                    font-weight: bold;
                    margin-right: 2rem;
                }

                .header-address-input-container {
                    display: none;
                }

                @media (min-width: 768px) {
                    .header-address-input-container {
                        display: block;
                        width: 24rem;
                    }
                }

                .header-address-relative {
                    position: relative;
                }

                .header-address-input {
                    width: 100%;
                    padding: 0.5rem 1rem;
                    border: 1px solid #e2e8f0;
                    border-radius: 0.5rem;
                    outline: none;
                    transition: border-color 0.2s;
                }

                .header-address-input:focus {
                    border-color: #000;
                }

                .header-address-icon {
                    position: absolute;
                    right: 0.75rem;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #a0aec0;
                }

                .header-right {
                    display: flex;
                    align-items: center;
                }

                .header-icon {
                    margin-left: 1.5rem;
                    font-size: 1.25rem;
                }

                .header-profile-img {
                    width: 2rem;
                    height: 2rem;
                    border-radius: 50%;
                    margin-left: 1.5rem;
                }

                /* Hero Section Styles */
                .hero-section {
                    position: relative;
                    height: 12.5rem;
                }

                .hero-overlay {
                    position: absolute;
                    inset: 0;
                    background-color: rgba(0, 0, 0, 0.4);
                }

                .hero-img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    filter: blur(0.3rem);
                }

                .hero-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 0 1rem;
                    height: 100%;
                    display: flex;
                    align-items: center;
                }

                .hero-title {
                    font-size: 1.5rem;
                    font-weight: bold;
                    color: #fff;
                }

                @media (min-width: 768px) {
                    .hero-title {
                        font-size: 2.25rem;
                    }
                }

                /* Order Summary Styles */
                .main-content {
                    padding-top: 5rem; /* Adjust based on header height */
                }

                .order-summary {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 0 1rem;
                    margin-top: -5rem;
                }

                .order-summary-content {
                    background-color: #fff;
                    border-radius: 1rem;
                    box-shadow: 0 0.25rem 1rem rgba(0, 0, 0, 0.1);
                    padding: 2rem;
                }

                .error-message {
                    color: red;
                    text-align: center;
                    padding: 0.625rem;
                }

                .order-title {
                    text-align: center;
                    margin-bottom: 0.625rem;
                }

                .order-list {
                    list-style: none;
                    padding: 0;
                }

                .order-item {
                    margin-bottom: 0.625rem;
                }

                .order-item-container {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0.625rem;
                    border-bottom: 1px solid #eee;
                }

                .order-token {
                    cursor: pointer;
                    color: blue;
                    text-decoration: underline;
                }

                .order-actions {
                    display: flex;
                }

                .order-button {
                    background-color: #007bff;
                    color: #fff;
                    padding: 0.5rem 0.75rem;
                    border: none;
                    border-radius: 0.25rem;
                    cursor: pointer;
                    margin-right: 0.3125rem;
                }

                .no-show-button {
                    background-color: #dc3545;
                    color: #fff;
                    padding: 0.5rem 0.75rem;
                    border: none;
                    border-radius: 0.25rem;
                    cursor: pointer;
                }

                .delivered-status {
                    color: green;
                    font-weight: bold;
                }

                .order-details {
                    margin-top: 1.25rem;
                    padding-top: 1.25rem;
                    border-top: 1px solid #ccc;
                }

                .order-details-title {
                    font-size: 1.25rem;
                }

                .order-table {
                    width: 100%;
                    border-collapse: collapse;
                }

                .order-table th,
                .order-table td {
                    padding: 0.625rem;
                    text-align: left;
                    border: 1px solid #ccc;
                }

                .order-total {
                    margin-top: 0.625rem;
                }

                /* Footer Styles */
                .footer {
                    background-color: #f2f2f2;
                    margin-top: 12.5rem;
                }

                .footer-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 3rem 1rem;
                }

                .footer-grid {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 2rem;
                }

                @media (min-width: 768px) {
                    .footer-grid {
                        grid-template-columns: repeat(4, 1fr);
                    }
                }

                .footer-heading {
                    font-weight: bold;
                    margin-bottom: 1rem;
                }

                .footer-list {
                    list-style: none;
                    padding: 0;
                }

                .footer-link {
                    color: #666;
                    cursor: pointer;
                    display: block;
                    margin-bottom: 0.5rem;
                }

                .footer-link:hover {
                    color: #000;
                }

                .footer-social {
                    display: flex;
                }

                .footer-social-icon {
                    color: #666;
                    cursor: pointer;
                    margin-right: 1rem;
                }

                .footer-social-icon:hover {
                    color: #000;
                }
                .no-orders{
                    text-align:center
                }
            `}</style>
        </div>
    );
};

export default OwnerOrders;